/**
 * Acciones de API para el Buscador Global
 */

import HttpClienteSeguroCore from '../../Servicios/HttpClienteSeguroCore';

export const BuscarGlobal = (params) => {
    return new Promise((resolve) => {
        HttpClienteSeguroCore.post('/Autorizacion/busquedaGlobal', {
            Texto: params.texto,
            UsuarioId: params.usuarioId,
            CompaniaId: params.companiaId,
            Idioma: params.idioma || 'ES',
            UrlBase: params.urlBase || ''
        })
            .then(response => resolve(response))
            .catch(error => resolve(error.response));
    });
};
